/* XIMONTHS article-body product clicks, v2. Reuses the existing Google tag. */
(function () {
  'use strict';
  if (window.__ximonthsBlogClicksInstalled) return;
  var root = document.querySelector('article.article-template .article-body .article-content') ||
    document.querySelector('.ximonths-blog-guide');
  if (!root) return;
  window.__ximonthsBlogClicksInstalled = true;
  var measurementId = 'G-3W0ZPGZG0K';
  var lastEvent = null;
  function allowed() {
    try {
      return window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  function click(event) {
    if (event.defaultPrevented || (event.type === 'auxclick' && event.button !== 1) || !allowed()) return;
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor || !root.contains(anchor)) return;
    var destination;
    try { destination = new URL(anchor.href, window.location.href); } catch (_) { return; }
    if (destination.origin !== window.location.origin || !/^\/products\/[a-z0-9-]+\/?$/.test(destination.pathname)) return;
    var page = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    var articleId = page && page.pageType === 'article' ? String(page.resourceId || '') :
      (anchor.getAttribute('data-content-id') || root.getAttribute('data-content-id'));
    if (!/^\d+$/.test(articleId || '')) return;
    var product = destination.pathname.split('/')[2];
    var position = anchor.getAttribute('data-cta-position') || 'body';
    var key = articleId + ':' + product + ':' + position;
    var now = Date.now();
    if (lastEvent && lastEvent.key === key && now - lastEvent.time < 700) return;
    if (typeof window.gtag !== 'function') return;
    lastEvent = { key: key, time: now };
    window.gtag('event', 'blog_product_click', {
      send_to: measurementId,
      article_id: articleId,
      article_path: window.location.pathname,
      product_handle: product,
      link_position: position,
      tracking_version: '2',
      transport_type: 'beacon'
    });
  }
  document.addEventListener('click', click, false);
  document.addEventListener('auxclick', click, false);
})();
